import { Box, Card, CardContent, Typography } from "@mui/material";
import {
  ComposedChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Brush,
  Legend,
} from "recharts";
import { ChartTooltip, COLORS } from "../../../../ui/Theme";
import NotFound from "../../../../components/notfound/NotFound";
import { ListDivider } from "../../../../ui/ListStyles";

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const { competition, avgPrice } = payload[0].payload;
    return (
      <ChartTooltip>
        <Typography sx={{ fontSize: "12px", fontWeight: 900 }}>
          {label}
        </Typography>
        <ListDivider flexItem />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            gap: 0.5,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              color: COLORS.ORANGE,
            }}
          >
            <Typography sx={{ fontSize: "12px" }}>درصد رقابت :</Typography>
            <Typography sx={{ fontSize: "12px", fontWeight: 900 }}>
              {competition}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              color: COLORS.BLUE,
            }}
          >
            <Typography sx={{ fontSize: "12px" }}>قیمت کالا </Typography>
            <Typography sx={{ fontSize: "10px" }}>(میلیون تومان) :</Typography>
            <Typography sx={{ fontSize: "12px", fontWeight: 900 }}>
              {avgPrice}
            </Typography>
          </Box>
        </Box>
      </ChartTooltip>
    );
  }
  return null;
};

const CommodityPriceChart = ({ chartData }) => {
  const formattedData = chartData.map((item) => ({
    x: item.trade_date,
    competition: item.competition,
    avgPrice: item.avg_price,
  }));

  const totalDataLength = formattedData?.length || 0;
  const startIndex = Math.max(0, totalDataLength - 50);
  const endIndex = totalDataLength - 1;

  return (
    <Card
      sx={{
        border: "1px solid",
        borderColor: COLORS.SOFTGRAY,
        padding: 0,
        minHeight: 500,
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{ fontSize: { xs: "16px", md: "20px" }, fontWeight: 700 }}
        >
          قیمت کالا
        </Typography>
        {chartData.length < 1 ? (
          <Box sx={{ height: 500 }}>
            <NotFound />
          </Box>
        ) : (
          <ResponsiveContainer width="100%" height={500}>
            <ComposedChart
              syncId="priceChart"
              data={formattedData}
              margin={{ top: 0, right: 0, bottom: 20, left: 0 }}
            >
              <CartesianGrid strokeDasharray="0 0" stroke={COLORS.SOFTGRAY} />
              <XAxis
                dataKey="x"
                stroke={COLORS.GRAY}
                tickMargin={10}
                angle={-25}
                tickFormatter={(date) => {
                  const [year, month] = date.split("-");
                  return `${year}-${month}`;
                }}
              />
              <YAxis
                yAxisId="left"
                stroke={COLORS.BLUE}
                tickMargin={10}
                textAnchor="center"
                orientation="left"
                domain={["auto", "auto"]}
              />
              <YAxis
                domain={["auto", "auto"]}
                tickMargin={20}
                yAxisId="right"
                orientation="right"
                stroke={COLORS.ORANGE}
                textAnchor="center"
              />
              <Tooltip  cursor={{ fill: COLORS.SOFTGRAY }} content={<CustomTooltip />} />
              <Legend
                verticalAlign="top"
                wrapperStyle={{
                  width: "fit-content",
                  top: -10,
                  right: 0,
                  lineHeight: "20px",
                }}
                formatter={(value) => {
                  if (value === "avgPrice") {
                    return (
                      <span style={{ marginRight: "5px" }}>قیمت کالا</span>
                    );
                  } else if (value === "competition")
                    return (
                      <span style={{ marginRight: "5px" }}>درصد رقابت</span>
                    );
                  return value;
                }}
              />
              <Bar yAxisId="right" dataKey="competition" fill={COLORS.ORANGE} />
              <Line
                yAxisId="left"
                type="monotone"
                dataKey="avgPrice"
                stroke={COLORS.BLUE}
                strokeWidth={2}
                dot={false}
              />
              <Brush
                dataKey="x"
                height={30}
                startIndex={startIndex}
                endIndex={endIndex}
                stroke={COLORS.BLUE}
                travellerWidth={10}
                y={460}
              />
            </ComposedChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
};

export default CommodityPriceChart;
